"use strict";
const OttClassificationTypes = {
    UNKNOWN: 'Unclassified',
    FULL: 'Fully Classified',
    PENDING: 'Pending',
    PARTIAL: 'Provider-Only',
    PROJECTED: 'IQ Classified'
};
const OttClassificationTypeMap = {
    0: OttClassificationTypes.UNKNOWN, // Unknown
    1: OttClassificationTypes.FULL, // Fixed (Full Match)
    2: OttClassificationTypes.FULL, // Direct (Full Match)
    3: OttClassificationTypes.PENDING, // Direct (Pending Classification)
    4: OttClassificationTypes.PENDING, // Direct (Pending, Port-based Match)
    5: OttClassificationTypes.FULL, // Indirect (Full Match)
    6: OttClassificationTypes.PARTIAL, // Indirect (Provider-only Match)
    7: OttClassificationTypes.PARTIAL, // Indirect (Provider-only, Port-based Match)
    8: OttClassificationTypes.PENDING, // Indirect (Pending Classification)
    9: OttClassificationTypes.PENDING, // Indirect (Pending, Port-based Match)
    10: OttClassificationTypes.UNKNOWN, // Projected (Full Match)
    11: OttClassificationTypes.UNKNOWN, // Projected (Pending Classification)
    12: OttClassificationTypes.UNKNOWN, // Projected (Pending, Port-based Match)
    13: OttClassificationTypes.UNKNOWN // Port-based Match
};
// overrides to use when projected values are allowed
const OttClassificationProjections = {
    10: OttClassificationTypes.PROJECTED, // Projected (Full Match)
    11: OttClassificationTypes.PENDING, // Projected (Pending Classification)
    12: OttClassificationTypes.PENDING // Projected (Pending, Port-based Match)
};
// values that are projected types
const OttClassificationProjectedValues = Object.keys(OttClassificationProjections).map((v) => Number.parseInt(v));
/**
 * @param classificationTypes {('UNKNOWN' | 'FULL' | 'PENDING' | 'PARTIAL' | 'PROJECTED')[]}
 * @param allowProjected {boolean?}
 * @returns {string}
 */
function getClassificationFilterValue(classificationTypes, allowProjected = false) {
    const classificationMap = {
        ...OttClassificationTypeMap,
        ...(allowProjected ? OttClassificationProjections : {})
    };
    const mappedClassificationTypes = classificationTypes.map((classificationType) => OttClassificationTypes[classificationType]);
    return Object.keys(classificationMap)
        .filter((value) => mappedClassificationTypes.includes(classificationMap[value]))
        .map((value) => Number.parseInt(value))
        .join(',');
}
/**
 * @param allowProjected {boolean?}
 * @returns {{label: string, value: string}[]}
 */
function getClassificationOptions(allowProjected = false) {
    const types = { ...OttClassificationTypes };
    if (!allowProjected) {
        delete types.PROJECTED;
    }
    return Object.entries(types)
        .map(([value, label]) => ({ label, value }))
        .sort((a, b) => a.label.localeCompare(b.label));
}
/**
 * Parse classification dimension to a classification type. By default, turn Projected to Unknown
 * @param classification {string}
 * @param allowProjected {boolean?}
 * @returns {string}
 */
function parseClassification(classification, allowProjected = false) {
    const value = Number.parseInt(classification?.match(/\((?<num>\d+)\)$/)?.groups.num) || 0;
    if (allowProjected && value in OttClassificationProjections) {
        return OttClassificationProjections[value];
    }
    return OttClassificationTypeMap[value] ?? OttClassificationTypes.UNKNOWN;
}
module.exports = {
    OttClassificationTypes,
    OttClassificationProjectedValues,
    getClassificationFilterValue,
    getClassificationOptions,
    parseClassification
};
